import { versioneInSituStore } from '../VersioneInSitu/store/VersioneInSitu.store';
import moment from 'moment';
import { printerHelper } from '../printer';
import { usersStore } from '../Utenti/store/users.store';

export async function exportForm(source: server.areaOmogenea, type: printer.type = printer.type.pdf): Promise<void> {
    let utenteCreatore = ["-- nessun creatore --"];
    let utentiRilevatori: string[] = ["-- nessun rilevatore --"];
    const users = await usersStore.getters.getAll();
    
    if (source.userId) {
        const user = users.find(f => f.id.toLowerCase() === source.userId.toLowerCase());
        if(user) utenteCreatore = [`${user.firstName} ${user.lastName}`];
    }

    if ((source.utentiRilevatori || []).length > 0) {
        utentiRilevatori = users.filter(f => source.utentiRilevatori.map(m => m.toLowerCase()).indexOf(f.id.toLowerCase()) !== -1)
            .map((m) => `${m.firstName} ${m.lastName}`)
            .sort((a, b) => a.localeCompare(b));
    }

    const printObj = [
        {
            header: "Dati Generali",
            data: {
                'Anno censimento': (await versioneInSituStore.getters.get(source.versioneId)).alias,
                'Id Area Omogenea': source.nome ? source.nome : '',
                'Località': source.localita ? source.localita : '',
                'Comune': source.comune ? source.comune : '',
                'Provincia': source.provincia ? source.provincia : '',
                'Superficie Area': source.area.toFixed(2) + ' m2',
            }
        }, {
            header: "Altro",
            data: {
                'Note': source.note ? source.note : null,
                'Data rilievo': source.data ? moment(source.data).format("DD-MM-YYYY") : '',
                'Utente creatore dell\'area': utenteCreatore,
                'Rilevatori in campo': utentiRilevatori
            }
        } as printer.group
    ];
    printerHelper.print(type, source.nome, 'Area Omogenea', printObj);
}